module.exports = __webpack_public_path__ + "static/media/tangodos.8e10df9a.png";